import { render, staticRenderFns } from "./addZoneChannels.vue?vue&type=template&id=c5118f5e&"
import script from "./addZoneChannels.vue?vue&type=script&lang=js&"
export * from "./addZoneChannels.vue?vue&type=script&lang=js&"
import style0 from "./addZoneChannels.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports